export default __webpack_public_path__ + "static/O0187-296e02a51d8820f7c7ee9231ec0515e4.png";